import React, { useCallback, useEffect } from 'react';
import { Route, useHistory } from 'react-router';
import Layout from './components/Layout';
import './custom.css'
import Eta from './components/Eta/Eta';
import CallLog from './components/CallLogs/CallLog';
import Outage from './components/Outages/Outage';
import Notification from './components/Notification/Notification';
import { ApplicationState } from './store';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationActions } from './store/NotificationSlice';
import { SecureRoute, Security, LoginCallback } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';

const App = () => {
    //Notification constants
    const notification = useSelector((state: ApplicationState) => state.Ui.notification);
    const notificationStatus = useSelector((state: ApplicationState) => state.Ui.show);
    const authState = useSelector((state: ApplicationState) => state.Auth);
    const dispatch = useDispatch();

    const history = useHistory();
    const restoreOriginalUri = useCallback(async (_: unknown, originalUri: string) => {
        history.replace(toRelativeUrl(originalUri || '/', window.location.origin))
    }, [])

    const customAuthHandler = async () => {
        const previousAuthState = authState.authClient.authStateManager.getPreviousAuthState();
        if (!previousAuthState || !previousAuthState.isAuthenticated) {
            // App initialization stage
            await authState.authClient.signInWithRedirect().then(() => {
                localStorage.setItem('authenticated', 'true');
            });
        }
        else {
            localStorage.setItem('authenticated', 'false');
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(NotificationActions.hideNotification({}));
        }, 7000)
        return () => clearTimeout(timer);
    }, [notificationStatus]);

    if (authState !== null) {
        return (
            <Security oktaAuth={authState.authClient} restoreOriginalUri={restoreOriginalUri} onAuthRequired={customAuthHandler}>
                {
                    notificationStatus && notification.status != null &&
                    (<Notification
                        status={notification.status}
                        title={notification.title}
                        message={notification.message} />)
                }
                <Layout>
                    <SecureRoute exact path='/' component={Eta} />
                    <SecureRoute path='/calllogs' component={CallLog} />
                    <SecureRoute path='/outages' component={Outage} />
                    <Route path='/' component={LoginCallback} />
                </Layout>
            </Security>
        );
    }
    else {
        return <></>
    }
};

export default App;